// "use client";

// import { useEffect, useState } from "react";
// import { useRouter } from "next/navigation";
// import { useAuth } from "../context/AuthContext";
// import { useQuery } from "@tanstack/react-query";
// import axiosInstance from "@/lib/axios";
// import { IndianRupee, ShoppingCart, Users, RefreshCw } from "lucide-react";
// import StatCard from "@/components/dashboard/DashboardCard";
// import RevenueChart from "@/components/dashboard/charts/revenue-chart";
// import TopSellingProducts from "@/components/dashboard/top-selling-products";
// import VisitorsChart from "@/components/dashboard/charts/visitors-chart";
// import OrderHeatmap from "@/components/dashboard/order-heatmap";
// import { TopCategoriesChart } from "@/components/dashboard/charts/top-categories-chart";
// import { InventoryMetrics } from "@/components/dashboard/inventory-metrics";
// import { MarketingMetrics } from "@/components/dashboard/marketing-metrics";
// import { CustomerFeedback } from "@/components/dashboard/customer-feedback";
// import { RecentOrders } from "@/components/dashboard/recent-orders";
// import { VisitTimeChart } from "@/components/dashboard/charts/visit-time-chart";
// import { AgeGroupChart } from "@/components/dashboard/charts/age-group-chart";
// import { SearchItemsChart } from "@/components/dashboard/charts/search-items-chart";
// import { NotificationsTable } from "@/components/notifications/notifications-table";
// import { ActivityLogTable } from "@/components/activity/activity-log-table";

// interface SalesData {
//   dayWiseSales: { date: string; total: number }[];
//   totalSales: number;
// }

// interface UserData {
//   firstName: string;
// }

// export default function Home() {
//   const router = useRouter();
//   const { isAuthenticated, loading } = useAuth();
//   const [dateRange, setDateRange] = useState({
//     startDate: new Date(new Date().setDate(new Date().getDate() - 30)),
//     endDate: new Date(),
//   });

//   const { data: salesData, isLoading: isSalesLoading } = useQuery({
//     queryKey: ["salesData", dateRange],
//     queryFn: async () => {
//       const response = await axiosInstance.get("/api/charts", {
//         params: {
//           startDate: dateRange.startDate.toISOString().split("T")[0],
//           endDate: dateRange.endDate.toISOString().split("T")[0],
//         },
//       });
//       return response.data as SalesData;
//     },
//     enabled: isAuthenticated,
//   });

//   const { data: userData, isLoading: isUserLoading } = useQuery({
//     queryKey: ["userData"],
//     queryFn: async () => {
//       const response = await axiosInstance.get("/api/auth/me");
//       return response.data as UserData;
//     },
//     enabled: isAuthenticated,
//   });

//   useEffect(() => {
//     if (!loading && !isAuthenticated) {
//       router.replace("/login");
//     }
//   }, [isAuthenticated, loading, router]);

//   if (loading || isSalesLoading) {
//     return (
//       <div className="w-full min-h-screen flex items-center justify-center bg-white dark:bg-[#0a0a0a]">
//         <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-gray-900 dark:border-white"></div>
//       </div>
//     );
//   }

//   return (
//     <div className="flex flex-col space-y-4 px-4 sm:px-4 lg:px-6 py-6 w-full max-w-9xl mx-auto">
//       <div className="sm:flex sm:justify-between sm:items-center mb-4">
//         <h1 className="text-3xl md:text-2xl text-gray-800 dark:text-gray-100 font-semibold">
//           Welcome Back, {userData?.firstName}!
//         </h1>
//       </div>

//       <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
//         <StatCard
//           title="Total Revenue"
//           value={`₹ 10000`}
//           icon={IndianRupee}
//           iconBg="bg-[#414143]"
//           iconColor="text-[#e6e5e5]"
//         />
//         <StatCard
//           title="New Orders"
//           value={500}
//           icon={ShoppingCart}
//           iconBg="bg-[#414143]"
//           iconColor="text-[#e6e5e5]"
//         />
//         <StatCard
//           title="New Customers"
//           value={400}
//           icon={Users}
//           iconBg="bg-[#414143]"
//           iconColor="text-[#e6e5e5]"
//         />
//         <StatCard
//           title="Repeat Rate"
//           value="25%"
//           icon={RefreshCw}
//           iconBg="bg-[#414143]"
//           iconColor="text-[#e6e5e5]"
//         />
//       </div>
//       <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
//         <div className="lg:col-span-2 mt-2">
//           <div className="bg-white dark:bg-[#18181a] px-6 pt-4 pb-6 border border-gray-100 dark:border-gray-100/10 rounded-xl">
//             <RevenueChart />
//           </div>
//         </div>
//         <div className="mt-2 bg-white dark:bg-[#18181a] px-2  border border-gray-100 dark:border-gray-100/10 rounded-xl">
//           <TopSellingProducts />
//         </div>
//       </div>
      

//       <div className="grid grid-cols-1 lg:grid-cols-4 gap-4">
//         <div className="lg:col-span-2 mt-2">
//           <div className="bg-white dark:bg-[#18181a] pt-4 pb-6 border border-gray-100 dark:border-gray-100/10 rounded-xl">
//             <VisitorsChart />
//           </div>
//         </div>
//         <div className="lg:col-span-2 mt-2">
//           <div className="bg-white dark:bg-[#18181a] pt-4 pb-6 border border-gray-100 dark:border-gray-100/10 rounded-xl">
//             <OrderHeatmap />
//           </div>
//         </div>
//       </div>

//       <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
//         <div className="pt-4 pb-6 mt-2 bg-white dark:bg-[#18181a] border border-gray-100 dark:border-gray-100/10 rounded-xl">
//           <TopCategoriesChart />
//         </div>
//         <div className="pt-4 pb-6 mt-2 bg-white dark:bg-[#18181a] border border-gray-100 dark:border-gray-100/10 rounded-xl">
//           <InventoryMetrics />
//         </div>
//         <div className="pt-4 pb-6 mt-2 bg-white dark:bg-[#18181a] border border-gray-100 dark:border-gray-100/10 rounded-xl">
//           <MarketingMetrics />
//         </div>
//       </div>

//       <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
//         <div className="lg:col-span-2 mt-2 bg-white dark:bg-[#18181a] border border-gray-100 dark:border-gray-100/10 rounded-xl">
//           <RecentOrders />
//         </div>
//         <div className="mt-2 bg-white dark:bg-[#18181a] border border-gray-100 dark:border-gray-100/10 rounded-xl">
//           <CustomerFeedback />
//         </div>
//       </div>

//       <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
//         <div className="lg:col-span-1 mt-2 bg-white dark:bg-[#18181a] border border-gray-100 dark:border-gray-100/10 rounded-xl">
//           <VisitTimeChart />
//         </div>
//         <div className="lg:col-span-1 mt-2 bg-white dark:bg-[#18181a] border border-gray-100 dark:border-gray-100/10 rounded-xl">
//           <AgeGroupChart />
//         </div>
//         <div className="lg:col-span-1 mt-2 bg-white dark:bg-[#18181a] border border-gray-100 dark:border-gray-100/10 rounded-xl">
//           <SearchItemsChart />
//         </div>
//       </div>
//       <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 mt-4 pb-6">
//         <div className="bg-white dark:bg-[#18181a] px-2 pt-4 pb-2 border border-gray-100 dark:border-gray-100/10 rounded-xl">
//           <ActivityLogTable />
//         </div>
//         <div className="bg-white dark:bg-[#18181a] px-2 pt-4 pb-2 border border-gray-100 dark:border-gray-100/10 rounded-xl">
//           <NotificationsTable />
//         </div>
//       </div>
//     </div>
//   );
// }

'use client'

import { Loader } from "@/components/ui/loader"

export default function Load() {
  return (
    <Loader/>
  )
}